import { guid } from "@progress/kendo-react-common";
import {
  IntlProvider, loadMessages, LocalizationProvider, useInternationalization
} from "@progress/kendo-react-intl";
import {
  ProgressBar
} from "@progress/kendo-react-progressbars";
import {
  Scheduler,
  SchedulerItem,
  SchedulerItemContent,
  TimelineView,
  SchedulerViewSlot,
  SchedulerEditSlot,
} from "@progress/kendo-react-scheduler";
import { Pager } from "@progress/kendo-react-data-tools";

import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useState } from 'react';
import faTruck from "../../../../assets/images/truck-solid.svg";
import usrImg from "../../../../assets/images/user.jpg";

import { Button, ButtonGroup, Card, Grid, Typography, CardContent, IconButton, Stack } from "@mui/material";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useSelector, useDispatch } from "react-redux";
import {
  customModelFields, displayDate, sampleDataWithCustomSchema
} from "../../../../../src/shared/common-utilities/utils/event-utc";
import AccountIcon from '../../../../shared/common-utilities/utils/AccountIcon';
import AccountIconWh from '../../../../shared/common-utilities/utils/AccountIconWh';
import ContainerIcon from '../../../../shared/common-utilities/utils/ContainerIcon';
import TrailerIcon from '../../../../shared/common-utilities/utils/TrailerIcon';
import ContainerIconWh from '../../../../shared/common-utilities/utils/ContainerIconWh';
import esMessages from "../../../../shared/common-utilities/utils/es.json";
import IconTruck from '../../../../shared/common-utilities/utils/IconTruck';
import IconTruckAll from '../../../../shared/common-utilities/utils/IconTruckAll';
import IconTruckAllWh from '../../../../shared/common-utilities/utils/IconTruckAllWh';
import IconTruckWh from '../../../../shared/common-utilities/utils/IconTruckWh';
import trailers from "../../../../shared/common-utilities/utils/trailer.json";
import trips from "../../../../shared/common-utilities/utils/trips.json";
import users from "../../../../shared/common-utilities/utils/users.json";
import vehicles from "../../../../shared/common-utilities/utils/vehicles.json";
import { Popup } from "@progress/kendo-react-popup";
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import { drageItemsReducer } from "../../../../shared/ReduxStore/Reducers/dragReducer";
import Spinner from "../Spinner/Spinner"
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveIcon from '@mui/icons-material/Save';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { NumericTextBox } from "@progress/kendo-react-inputs";

import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ToggleMenuForConfig from "../../../../shared/common-utilities/common/toggleMenuForConfig/toggleMenuForConfig";
import commonApiService from "../../../../shared/common-utilities/services/commonApiService";
import TrailerBlIcon from "../../../../shared/common-utilities/utils/TrailerBlIcon";
import { baseUrl } from "../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts";
import { Accordion, AccordionSummary, AccordionDetails } from "../../../../shared/common-utilities/common/CommonStyleComponent";
import { useEffect } from "react";
import { kendoEventsData,kendoResourceData } from "./data";
import CheckBox from "devextreme-react/cjs/check-box";

let service = getSetDataService()
let apiService = commonApiService();

loadMessages(esMessages, "es-ES");


const Agenda = (props) => {
  const chunks = 2;
  const locales = [
    {
      language: "en-US",
      locale: "en",
    },
    {
      language: "es-ES",
      locale: "es",
    },
  ];

  const itemsPerPage = 15
  const defaultSkip = 15
  const initialType = "numeric";
  const initialPageState = {
    skip: 0,
    take: itemsPerPage,
    buttonCount: 5,
    type: initialType,
    info: true,
    pageSizes: false,
    previousNext: true,
    responsive: true,
  };
  const now = new Date();
  var tommorow = new Date();
  tommorow.setDate(tommorow.getDate() + 1)
  const [date, setDate] = React.useState(new Date());
  const [locale, setLocale] = React.useState(locales[0]);
  const [timezone, setTimezone] = React.useState("Etc/UTC");
  const [orientation, setOrientation] = React.useState("vertical");
  const [data, setData] = React.useState(
    kendoEventsData   
  );
  const [showBothImages, setShowBothImages] = useState(true);
  const [showSecondImage, setShowSecondImage] = useState(false);
  const [showUserImage, setUserImage] = useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [IconActive, setIconSelected] = useState("vehiclePlanning");
  const [isShow, setFlagShow] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [days, setDays] = useState(15);
  const [expanded, setExpanded] = React.useState('panel1');
  const [isShowToggleForConfig, setFlagShowToggleForConfig] = useState(false);
  const [showAgenda, setShowAgenda] = useState(
   kendoResourceData
  );
  const [toggleconfigcheckboxes, setToggleconfigCheckboxes] = useState({});
  const [toggleconfigcheckboxesplan, setToggleconfigcheckboxesplan] = useState({});
  const [toggleconfigActions, setToggleconfigActions] = useState([]);
  const [pageState, setPageState] = React.useState(initialPageState);
  const [totalPages, setTotalPages] = useState(showAgenda.length);
  const [isPrevPageDisabled, setIsPrevPageDisabled] = useState(true);
  const [isNextPageDisabled, setIsNextPageDisabled] = useState(true);

  // const pageSizes = [5, 10, 20];


  let { skip, take, ...rest } = pageState;
  // const currentItems = showAgenda.slice(skip, skip + take);
  const currentItems = showAgenda

  const handlePageChange = (event) => {
    const { skip, take } = event;
    console.log("pagechange", event)
    setPageState({
      ...pageState,
      skip: skip,
      take: take,
    });
  };

  const [progressbars, setProgressbars] = useState([
    {
      text: <div className="truck-bg"><ProgressBar value={45} chunkCount={chunks} style={{ width: "80px" }} /></div>,
      value: 1,
    }
  ]);

  const prtFilterComponents = [
    { type: 'DatePicker', key: 'ptStartingDate', value: startDate, label: 'Start date', placeholder: 'Start date...' },
    { type: 'NumericTextBox', key: 'daysToShow', value: days, label: 'Days to Show', placeholder: 'Please enter value' },
  ];

  const dataRelatedAction = ['Settings', 'New Window', 'Refresh'];
  const defDataRelatedAction = ['Settings'];
  const planRelatedAction = [];

  const toDayDate = new Date();
  const minDate = new Date(toDayDate.getFullYear() - 50, toDayDate.getMonth(), toDayDate.getDate());
  const maxDate = new Date(toDayDate.getFullYear() + 50, toDayDate.getMonth(), toDayDate.getDate());

  const CustomItem = (props) => {
    const intl = useInternationalization();
    const ref = React.useRef(null);
    const [show, setShow] = React.useState(false);
    const { onFocus, onBlur } = props;
    let startDate = props.start.toISOString().split('T')[0]
    let endDate = props.end.toISOString().split('T')[0]
    let today = new Date(props.start);
    let Christmas = new Date(props.end);
    let diffMs = (Christmas - today); // milliseconds between now & Christmas
    let diffDays = Math.floor(diffMs / 86400000); // days
    let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    let loadloc = props.title
    let unloadloc = props.title
    const handleFocus = React.useCallback(
      (event) => {
        setShow(true);

        // Call the default `onFocus` handler
        if (onFocus) {
          onFocus(event);
        }
      },
      [onFocus]
    );
    const handleBlur = React.useCallback(
      (event) => {
        setShow(false);

        // Call the default `onBlur` handler
        if (onBlur) {
          onBlur(event);
        }
      },
      [onBlur]
    );
    return (
      <>
        <SchedulerItem
          {...props}
          ref={ref}
          style={{
            ...props.style,
            height: 70,
          }}
          onFocus={handleFocus}
          onBlur={handleBlur}
        >
          <SchedulerItemContent
            style={{
              ...props.style,
              height: 70,
            }}  >
            <div title={props.title}>
              <>
                <div style={{ borderBottom: "1px solid #109faf" }} >
                  <span style={{ paddingRight: "15px" }}><img src={usrImg} style={{ height: "15px", width: "15px", borderRadius: "50%" }} alt="user" />{props.dataItem.driver}</span>&nbsp;
                  <span className='pr-1'><img src={faTruck} style={{ height: "15px", width: "15px" }} alt="vehicle" />{props.dataItem.vehicle}</span>
                  <span style={{ paddingLeft: "15px" }} >{props.dataItem.addressname}</span>
                  <span style={{ float: "right" }}>{props.dataItem.sequenceNo}</span>
                </div>
              </>
              <div style={{ display: 'flex' }}>
                <div style={{ border: "1px solid #014b43", width: '100px', margin: '0px 100px', background: '#0a7367', padding: '1px 5px', textAlign: 'center' }}>{props.dataItem.actionCode}</div>
              </div>
            </div>
          </SchedulerItemContent>

        </SchedulerItem>
        <Popup
          show={show}
          anchorAlign={{ horizontal: "center", vertical: "top" }}
          popupAlign={{ horizontal: "center", vertical: "bottom" }}
          anchor={ref.current?.element}
        >
          <div className="rounded" style={{ overflow: "hidden", width: "300px" }} >
            <div className="p-1" style={{ padding: '10px' }} >
              <div style={{ background: '#023e84', color: '#fff', fontSize: "15px", padding: "7px 5px" }} >{props.title}</div>
              <table>
                <tr><td>Start</td><td>{startDate} {intl.formatDate(props.zonedStart, "t")}</td></tr>
                <tr><td>End</td><td>{endDate} {intl.formatDate(props.zonedEnd, "t")}</td></tr>
                <tr><td>Trip Actions</td><td>2</td></tr>
                <tr><td>Total Duration</td><td>{diffHrs + ':' + diffMins} HH</td></tr>
                <tr><td>Total Distance</td><td>{props.dataItem.TotalDistance} KM</td></tr>
                <tr></tr>
                <tr style={{ marginTop: "15px" }}><td>LOAD Location</td><td>#{loadloc}</td></tr>
                <tr><td>LOAD Duration</td><td>#1 HH</td></tr>
                <tr><td>Driver</td><td>Driver 1</td></tr>

              </table>
            </div>
          </div>
        </Popup>
      </>
    );
  }

  const CustomButtons = (prop) => {
    return (
      <>

        <div className='my-buttons'>
          <ButtonGroup variant="outlined" aria-label="text button group">
            <Button onClick={() => variousPlanning()} className={IconActive === 'variousPlanning' ? 'active' : ''} >
              {IconActive === 'variousPlanning' ? <IconTruckAllWh /> : <IconTruckAll />}
            </Button>
            <Button onClick={() => vehiclePlanning()} className={IconActive === 'vehiclePlanning' ? 'active' : ''} >
              {IconActive === 'vehiclePlanning' ? <IconTruckWh /> : <IconTruck />}
            </Button>
            <Button onClick={() => trailerPlanning()} className={IconActive === 'trailerPlanning' ? 'active' : ''}>
              {IconActive === 'trailerPlanning' ? <ContainerIconWh /> : <ContainerIcon />}
            </Button>
            <Button onClick={() => driverPlanning()} className={IconActive === 'driverPlanning' ? 'active' : ''}>
              {IconActive === 'driverPlanning' ? <AccountIconWh /> : <AccountIcon />}
            </Button>
            <Button onClick={() => chassisPlanning()} className={IconActive === 'chassisPlanning' ? 'active' : ''} >
              {IconActive === 'chassisPlanning' ? <TrailerIcon /> : <TrailerBlIcon />}
            </Button>
          </ButtonGroup>
        </div>

      </>
    )
  }

  const vehiclePlanning = () => {
    callApi("vehiclePlanning")
    // getResourceData("vehicles", "vehicleType eq 'TRUCK'");
    setShowBothImages(false)
    setShowSecondImage(true)
    setIconSelected('vehiclePlanning')
    setProgressbars([
      {
        text: <div className="truck-bg"><ProgressBar value={55} chunkCount={chunks} style={{ width: "80px" }} /></div>,
        value: 1,
      }
    ])
  }
  const variousPlanning = () => {
    callApi("variousPlanning")
    getResourceData("variousResources")
    setShowBothImages(true)
    setShowSecondImage(false)
    setIconSelected('variousPlanning')
    setUserImage(false)
    setProgressbars([
      {
        text: <div className="truck-bg"><ProgressBar value={null} chunkCount={chunks} style={{ width: "80px" }} /></div>,
        value: 1,
      }
    ])
  }
  const trailerPlanning = () => {
    callApi("trailerPlanning")
    getResourceData("trailers")
    setShowBothImages(false)
    setShowSecondImage(true)
    setUserImage(false)
    setIconSelected('trailerPlanning')
    setProgressbars([
      {
        text: <div className="truck-bg"><ProgressBar value={null} chunkCount={chunks} style={{ width: "80px" }} /></div>,
        value: 1,
      }
    ])

  }
  const driverPlanning = () => {
    callApi("driverPlanning")
    getResourceData("drivers")
    setShowSecondImage(false)
    setShowBothImages(false)
    setUserImage(true)
    setIconSelected('driverPlanning')
    setProgressbars([
      {
        text: <div className="truck-bg"><ProgressBar value={null} chunkCount={chunks} style={{ width: "80px" }} /></div>,
        value: 1,
      }
    ])
  }
  const chassisPlanning = () => {
    callApi("chassisPlanning")
    getResourceData("chassis")
    setShowAgenda([])
    setShowSecondImage(false)
    setShowBothImages(false)
    setUserImage(true)
    setIconSelected('chassisPlanning')
    setProgressbars([
      {
        text: <div className="truck-bg"><ProgressBar value={null} chunkCount={chunks} style={{ width: "80px" }} /></div>,
        value: 1,
      }
    ])
  }

  const handleDateChange = React.useCallback(
    (event) => {
      setDate(event.value);
    },
    [setDate]
  );

  const handleDataChange = React.useCallback(
    ({ created, updated, deleted }) => {      
      setData((old) =>
        old
          .filter(
            (item) =>
              deleted.find((current) => item ? current.TaskID === item.TaskID : false) ===
              undefined
          )
          .map(
            (item) =>
              updated.find((current) => item ? current.TaskID === item.TaskID : false) || item
          )
          .concat(
            created.map((item) =>
              Object.assign({}, item, {
                TaskID: guid(),
              })
            )
          )
      );
    },
    [setData]
  );
  //#region Hook Selctor
  const drageItems = useSelector(state => state.drag);
  const globalData = useSelector(state => state.globalData);
  const dispatch = useDispatch()
  //#endregion Hook Selctor

  const MyScheduler = React.createRef();
  const refData = React.useRef();
  refData.current = data;

  React.useEffect(() => {
    let newEvent = {
      "id": data.length + 1,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-356-DB",
      "Title": "F_10038010",
      "recurrenceRule": null,
      "TaskID": guid()
    }
    const newData = [newEvent, ...refData.current];
    refData.current = newData;
    // handleDataChange
    setData(newData);
    // setTimeout(() => {
    //   setIsLoading(false)
    // }, 1500)
    // getResourceData("vehicles", "vehicleType eq 'TRUCK'");
    // callApi();

    setIsLoading(false)    // let schedulerElement = MyScheduler?.current?.element;
    // schedulerElement.addEventListener("drop", handleDropItem);
    // schedulerElement.addEventListener("dragover", (e) => e.preventDefault());
  }, []);

  const parseAdjust = eventDate => {
    const currentYear = new Date().getFullYear();
    const date = new Date(eventDate);
    date.setFullYear(currentYear);
    return date;
  };
  const handleDropItem = (e) => {
    let start = e.target.getAttribute("data-slot-start");
    let end = e.target.getAttribute("data-slot-end");
    let startDate = new Date(parseInt(start));
    let tempendDate = new Date(parseInt(end));

    let endDate = new Date(tempendDate.setTime(tempendDate.getTime() + (5 * 60 * 60 * 1000)));
    // let newEvent = {
    //   "TaskID": data.length + 1,
    //   // "ContainerID": 1,
    //   // "TripID": +e.target.dataset.slotGroup + 1,
    //   "Title": "F_10038010 - (Soest to Meppel)",
    //   "Description": "",
    //   "StartTimezone": null,
    //   // "Start": startDate,
    //   // "End": endDate,
    //   "EndTimezone": null,
    //   "TotalDuration": 5.5,
    //   "TotalDistance": 95,
    //   "RecurrenceRule": "FREQ=WEEKLY;BYDAY=TU,TH",
    //   "RecurrenceException": null,
    //   "ImageUrl": "src/assets/images/download.jpg",
    //   "isAllDay": false,
    //   Start: parseAdjust(startDate),
    //   End: parseAdjust(endDate),
    //   TripID: +e.target.dataset.slotGroup + 1,
    //   ContainerID: 1,
    //   image: "https://d585tldpucybw.cloudfront.net/sfimages/default-source/default-album/release_webinar_kui_1920x440_lp.png?sfvrsn=23989f80_0"
    // }
    // let newEvent = {
    //   id: data.length + 1,
    //   title: "F_10038010",
    //   StartTimezone: null,
    //   start: startDate,
    //   end: endDate,
    //   resourceNo:"DEMO"
    // };
    let newEvent = {
      "id": data.length + 1,
      "Start": startDate,
      "End": endDate,
      "isAllDay": false,
      "resourceNo": "DEMO",
      "Title": "F_10038010",
      "recurrenceRule": null,
      "TaskID": guid()
    }
    const newData = [newEvent, ...refData.current];
    refData.current = newData;
    // handleDataChange
    setData(newData);
    const obj = {
      source: drageItems?.source,
      eventType: drageItems?.eventType,
      destination: 'Agenda',
      isTripGenerated: false,
      items: drageItems?.items
    }
    // dispatch(drageItemsReducer(obj))
  };

  const handleClick = () => {
    setFlagShow(!isShow);
  }
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const SaveViewsFilter = () => {
    console.log('called save Views Filter');
  }
  const showToggleMenu = () => {
    setFlagShowToggleForConfig(!isShowToggleForConfig);
  }

  const onDateChange = (componentValue, e) => {
    if (event.type == 'click') {
      const obj = {
        type: "blur",
        target: { value: e }
      }
      onChange(componentValue.key, obj)
    }
  }

  const getResourceData = (type, filter) => {
    setIsLoading(true)
    let url
    if (type === "chassis") {
      url = `${baseUrl}/trailers?&${filter}`
    } else {
      url = `${baseUrl}/${type}?&${filter}`
    }
    apiService.get(url).then((response) => {
      let newData = response.value.map(item => {
        if (type === "variousResources") {
          return { ...item, ["resourceNo"]: item.codeResource }
        } else if (type === "trailers" || type === "chassis") {
          return { ...item, ["resourceNo"]: item.codeTrailer }
        } else if (type === "drivers") {
          return { ...item, ["resourceNo"]: item.codeDriver }
        } else if (type === "vehicles") {
          return { ...item, ["resourceNo"]: item.codeVehicle }
        }
      })

      if (type === "trailers") {
        newData = newData.filter((item) => item.trailerChassis === "Trailer")
      } else if (type === "chassis") {
        newData = newData.filter((item) => item.trailerChassis === "Chassis")
      }
      // let data = { ...newData[0] }
      // data.resourceNo = "Group " + data.resourceNo
      // data.isGroup = true
      // data = [data]
      // setShowAgenda(data.concat(newData))      
      setTotalPages(response.value.length)
      setIsLoading(false)
    })
  }

  const callApi = (type = "vehiclePlanning", startingDate = startDate, totalDays = days) => {
    setIsLoading(true)
    const dateObject = new Date(startingDate);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObject.getDate().toString().padStart(2, '0');
    const endDate = service.dateFormat(dateObject, "endDate", totalDays)

    const formattedDate = `${year}-${month}-${day}`;
    const url = `${baseUrl}/${type}?$filter=ptStartingDate gt ${formattedDate} and ptEndingDate lt ${endDate}`
    apiService.get(url).then(response => {
      const resData = _.groupBy(response.value, 'tripNo')
      let newData = []
      for (const key in resData) {
        if (resData.hasOwnProperty(key)) {
          const prGroup = [].concat(..._.sortBy(_.groupBy(resData[key], 'partialtripLineNo'), "routeLineNo"))
          const sortByTime = _.sortBy(prGroup, ['startingDate', 'startingTime'])
          prGroup[0].endAddress = prGroup[prGroup.length - 1].addressname;
          prGroup[0].endingDate = prGroup[prGroup.length - 1].startingDate;
          prGroup[0].endingTime = prGroup[prGroup.length - 1].startingTime;

          prGroup[0].ctStartDate = sortByTime[0].startingDate;
          prGroup[0].ctStartTime = sortByTime[0].startingTime;

          prGroup[0].ctEndDate = sortByTime[sortByTime.length - 1].startingDate;
          prGroup[0].ctEndTime = sortByTime[sortByTime.length - 1].startingTime;

          newData.push(prGroup[0])
        }
      }

      const sampleDataWithCustomSchema = newData.map((dataItem) => ({
        ...dataItem,
        Start: new Date(dataItem.ctStartDate + ' ' + dataItem.ctStartTime),
        End: new Date(dataItem.ctEndDate + ' ' + dataItem.ctEndTime),
        // TripID: dataItem.tripNo,
        // ContainerID: dataItem.status,
        TaskID: dataItem.sequenceNo,
        ContainerID: 1,
        TripID: 1,
        Title: dataItem.actionCode,
        Description: "",
        StartTimezone: null,
        EndTimezone: null,
        TotalDuration: dataItem.actionDurationHM,
        TotalDistance: dataItem.distance,
        RecurrenceRule: "FREQ=WEEKLY;BYDAY=WE",

        RecurrenceException: null,
        ImageUrl: "src/assets/images/download.jpg",
        isAllDay: false,
        image: "https://d585tldpucybw.cloudfront.net/sfimages/default-source/default-album/release_webinar_kui_1920x440_lp.png?sfvrsn=23989f80_0"
      }));

      setData(sampleDataWithCustomSchema)
      setIsLoading(false)
    })
  }

  const onChange = (key, value) => {
    if ((value.key == "Enter" && key === 'ptStartingDate') || (value.type == "blur" && key === 'ptStartingDate')) {
      value = new Date(value?.target?.value)
      if (value == 'Invalid Date' || (value < minDate) || (value > maxDate))
        return
      callApi(IconActive, value)
      setStartDate(value)
    }
    if (key === 'daysToShow') {
      callApi(IconActive, startDate, value.target.value)
      setDays(value.target.value)
    }
  }

  const toggleDataActionsRendering = (checkboxes) => {
    setToggleconfigCheckboxes(checkboxes);
    // saveToggleActionSelectedData('Data', checkboxes);
  };
  const droppedItemsChangeForRightClick = (droppedItems) => {
    setToggleconfigActions(droppedItems);
    // saveToggleActionSelectedData('Action', droppedItems);
  };
  const toggleDataActionsRenderingPlan = (checkboxesPlan) => {
    setToggleconfigcheckboxesplan(checkboxesPlan);
    // saveToggleActionSelectedData('Plan', checkboxesPlan);
  };
  let lastScrollTop = 0;
  const onScroll = (e) => {
    console.log("data", showAgenda)
    const ele = document.getElementById("testdev")?.getElementsByClassName("k-scheduler-timeline-view")[0]
    // let scrollbarHeight =  50
    // var styleElement = document.createElement('style');
    // styleElement.textContent = `
    //   .k-scheduler-timeline-view::-webkit-scrollbar {
    //     height: ${scrollbarHeight}px !important;
    //   }
    // `;
    // console.log(styleElement)
    let st = ele.scrollTop;
    if (st > lastScrollTop) {
      console.log('down');
      if (ele.scrollHeight - ele.scrollTop - ele.clientHeight < 50 && currentItems.length < showAgenda.length) {
        console.log("the element reach the end of scroll", currentItems)
        console.log("the element reach the end of scroll", showAgenda)
        let skip = showAgenda.findIndex(e => e.id == currentItems[0].id) + 5
        if (skip > showAgenda.length - 15) {
          skip = showAgenda.length - 15
        }
        if (currentItems[currentItems.length - 1].id != showAgenda[showAgenda.length - 1].id) {
          // setTimeout(() => {
          //   handlePageChange({skip:skip,take:15})
          //   ele.scrollTo({top: 50, behavior: "smooth"})
          // }, 100);  
          setIsNextPageDisabled(false)
          setIsPrevPageDisabled(true)
        }
        // document.head.appendChild(styleElement);
        // handlePageChange({skip:0,take:currentItems.length+15})
      }
    } else if (st < lastScrollTop) {
      // console.log('up',ele.scrollTop);
      if (ele.scrollTop <= 0) {
        console.log("reached at top of div")

        let skip = pageState.skip - 5
        if (skip < 0) {
          skip = 0
        }
        if (currentItems[0].id != showAgenda[0].id) {
          setIsPrevPageDisabled(false)
          setIsNextPageDisabled(true)
          // setTimeout(() => {
          //   handlePageChange({skip:skip,take:15})
          //   ele.scrollTo({top: 50, behavior: "smooth"})
          // }, 100);

        }
      }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling


  }
  useEffect(() => {
    const ele = document.getElementById("testdev")?.getElementsByClassName("k-scheduler-timeline-view")[0]
    ele?.addEventListener('scroll', onScroll, { passive: true });
    console.log(ele)

    return () => {
      ele?.removeEventListener('scroll', onScroll);
    };
  }, [onScroll])

  const onSchedulerDrop = (e) => {
    console.log(drageItems)
  }
  const goToNextPage = (e) => {
    let skip = showAgenda.findIndex(e => e.id == currentItems[0].id) + defaultSkip
    const ele = document.getElementById("testdev")?.getElementsByClassName("k-scheduler-timeline-view")[0]

    if (skip > showAgenda.length - itemsPerPage) {
      skip = showAgenda.length - itemsPerPage
    }
    handlePageChange({ skip: skip, take: itemsPerPage })
    ele.scrollTo({ top: 0, behavior: "smooth" })
  }

  const goToPrevPage = (e) => {
    console.log("goToPrevPage")
    let skip = pageState.skip - defaultSkip
    if (skip < 0)
      skip = 0
    handlePageChange({ skip: skip, take: itemsPerPage })
  }

  const CustomEditSlot = (props) => {
    const [formItem, setFormItem] = React.useState(null);
    const handleFormItemChange = React.useCallback(
      (event) => {
        if (!props.group.resources[0].isGroup) {
          setFormItem(event.value);
        }
      },
      [props.group]
    );
    return (
      <SchedulerEditSlot
        {...props}
        formItem={formItem}
        onFormItemChange={handleFormItemChange}
        editable={!props.group.resources[0].isGroup}
      />
    );
  };
  const CustomViewSlot = (props) => {
    return (
      <SchedulerViewSlot
        {...props}
        style={{
          ...props.style,
          cursor: props.group.resources[0].isGroup ? "no-drop" : undefined,
        }}
        editable={!props.group.resources[0].isGroup}
      />
    );
  };

  return (
    <>
      {isLoading ? (<Spinner />) : (<></>)
      }
      <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }}>
        <Box sx={{ p: 0, display: 'flex', }} className="filterbar-bg ">
          {
            isShow &&
            <Grid item={true} component={Card} elevation={0} width={250} square className='overflow-datafix' sx={{ backgroundColor: 'info.light' }}>
              <CardContent sx={{ padding: 0 }}>
                <Box sx={{ flexGrow: 0, p: 1, backgroundColor: 'info.light', marginBottom: 0 }}>
                  <div>
                    <Accordion className="mui-acc" expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                      <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', paddingLeft: .5 }} color="primary" gutterBottom>My Views</Typography>
                        <IconButton aria-label="Save" color='primary' sx={{ padding: .3 }} onClick={SaveViewsFilter}>
                          <SaveIcon />
                        </IconButton>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Box className='border-b' sx={{ flexGrow: 0, p: 0, backgroundColor: 'info.light', marginBottom: 1 }}>
                          <Stack spacing={1} sx={{}}>
                            {prtFilterComponents.map((component, index) => {
                              return (
                                <Box key={index} sx={{ justifyContent: 'center' }}>
                                  <Typography variant="body2" sx={{ pr: 0.5 }}>{component.label} :</Typography>
                                  {component.type === 'DatePicker' && (
                                    <DatePicker
                                      showIcon
                                      selected={startDate}
                                      dateFormat="MM/dd/yyyy"
                                      minDate={minDate}
                                      maxDate={maxDate}
                                      onKeyDown={(value) => onChange(component.key, value)}
                                      // onBlur={(value) => onFilterComponentChange(component.key, value)}
                                      onChange={(value) => onDateChange(component, value)}
                                    />
                                  )}
                                  {component.type === 'NumericTextBox' && (
                                    <NumericTextBox
                                      placeholder={component.placeholder}
                                      format="n"
                                      min={0}
                                      max={15}
                                      autoComplete="off"
                                      value={days || ''}
                                      valid={component.value < 15}
                                      onChange={(value) => onChange(component.key, value)}
                                    // onBlur={(value) => onDayChange(component,value,event)}
                                    />
                                  )}
                                </Box>
                              )
                            }
                            )}
                          </Stack>
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </Box>
              </CardContent>
            </Grid>
          }
          <Grid item={true} elevation={0} sx={{ flexGrow: 0, pl: '0', alignItems: 'center' }}>
            <Box className="arrow-btn" onClick={handleClick}>
              {isShow ? <ArrowBackIosRoundedIcon color='secondary.contrastText' /> : <ArrowForwardIosRoundedIcon color='secondary.contrastText' />}
            </Box>
          </Grid>
          <Grid item xs component={Card} elevation={0} square className="ctm-Scheduler grid-movement agenda" >
            
            <Card square variant="outlined" sx={{ width: '100%', }}>

              {/* <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Agenda</Typography>
            </Box> */}

              <Box sx={{ p: 1, position: 'relative' }} >
              
                {/* <div>Showing {pageState.skip + 1} to {pageState.skip + pageState.take} of {showAgenda.length}</div> */}
                <CustomButtons sx={{ p: 1, position: 'relative' }}  variousPlanning={variousPlanning} vehiclePlanning={vehiclePlanning} trailerPlanning={trailerPlanning} driverPlanning={driverPlanning} /><CustomButtons/>
                <div onDrop={e => onSchedulerDrop(e)} onDragOver={e => e.preventDefault(e)}>
                  <LocalizationProvider language={locale.language} >
                    <IntlProvider locale={locale.locale}>
                      <Tooltip anchorElement="target" position="top" parentTitle={true}>
                        <Scheduler
                          id="testdev"
                          // Header={(headerProps) => <CustomSchedulerHeader {...headerProps} />}
                          routeName={'/scheduler'}
                          isCrossIcon={false}
                          showWorkHours={false}
                          // height={"max-content"}
                          height={props.height ? props.height : "700px"}
                          data={data}
                          onDataChange={handleDataChange}
                          item={CustomItem}
                          date={startDate}
                          onDateChange={handleDateChange}
                          editable={true}
                          // timezone={timezone}
                          modelFields={customModelFields}
                          ref={MyScheduler}
                          group={{
                            resources: ["Trip"],
                            orientation,
                          }}
                          resources={[
                            {
                              name: "Trip",
                              data: currentItems?.map(item => ({
                                ...item,
                                icon: <img src={item?.icon} alt={item?.resourceNo} />,
                                text: (
                                  <>
                                    <span style={{ display: "flex" }} >
                                      {IconActive === "driverPlanning" ? (
                                        <>
                                          <div style={{ marginRight: "10px", height: "15px" }} >
                                            <AccountIconWh />
                                          </div>
                                          <div >
                                            {item?.firstName === undefined ? item?.resourceNo : item?.firstName + " " + item?.lastName}
                                          </div>
                                        </>
                                      ) :
                                        (<>                                         
                                          <div style={{ marginRight: "10px", height: "15px" }} >
                                            <CheckBox></CheckBox>
                                          </div>
                                          <div style={{ marginRight: "10px", height: "15px" }} >
                                            <LocalShippingIcon color='primary' />
                                          </div>
                                          <div >
                                            {item?.resourceNo}
                                          </div>
                                        </>)
                                      }
                                    </span>
                                  </>
                                ),
                              })),
                              field: "resourceNo",
                              valueField: "resourceNo",
                              textField: "resourceNo",
                              //colorField: "color",
                              imageField: "icon",
                            },
                          ]}
                          viewSlot={CustomViewSlot}
                          editSlot={CustomEditSlot}
                        >
                          <TimelineView
                            title="Hour-By-Hour"
                            numberOfDays={3}
                            //columnWidth={80}
                            slotDuration={60}
                            slotDivisions={1}
                            startTime={"00:00"}
                            endTime={"00:00"}
                            workDayStart={"23:59"}
                            workDayEnd={"23:59"}
                            isAllDay={true}
                            showWorkHours={false}
                          />
                        </Scheduler>
                      </Tooltip>
                    </IntlProvider>
                  </LocalizationProvider>
                </div>
              </Box>

              <Box>

              </Box>
              {/* <Pager
                  className="custom-pager"
                  // style={{ position: "absolute",top:"13px",right:"15px",zIndex:2 }} 
                  skip={skip}
                  take={take}
                  total={totalPages}
                  buttonCount={pageState.buttonCount}
                  info={pageState.info}
                  type={pageState.type}
                  pageSizes={pageState.pageSizes ? pageSizes : undefined}
                  previousNext={pageState.previousNext}
                  onPageChange={handlePageChange}
                /> */}
              {/* <Button style={{ float: 'right' }} onClick={goToNextPage} disabled={isNextPageDisabled}>Next</Button> */}
              {/* <Button style={{ float: 'right', zIndex: 10000 }} onClick={goToPrevPage} disabled={isPrevPageDisabled}>Previous</Button> */}
            </Card>
          </Grid>
          <Box className='filterbar-bg' sx={{ display: 'flex', }}>
            <Box className="arrow-btn" onClick={showToggleMenu}>
              {isShowToggleForConfig ? <ArrowForwardIosRoundedIcon color='secondary.contrastText' /> : <ArrowBackIosRoundedIcon color='secondary.contrastText' />}
            </Box>
            <Box className="overflow-datafix fix-heightMovement" sx={{ position: 'relative' }}>
              {isShowToggleForConfig &&
                <ToggleMenuForConfig gridFlagVal={"agenda"} gridSelectedDataAction={toggleconfigcheckboxes} gridSelectedPlanAction={toggleconfigcheckboxesplan} gridSelectedActions={toggleconfigActions} gridMenuItems={dataRelatedAction} griddefDataRelatedAction={defDataRelatedAction} gridPlanMenuItems={planRelatedAction} onCheckboxChange={toggleDataActionsRendering} onDroppedItemsChange={droppedItemsChangeForRightClick} onCheckboxChangePlan={toggleDataActionsRenderingPlan} />
              }
            </Box>
          </Box>
        </Box>
      </Grid>
    </>

  )
};

export default Agenda;